import { createRouter, createWebHistory } from 'vue-router';
const routes = [
    {
        path: '/',
        redirect: '/photos'
    },
    {
        path: '/photos',
        name: 'Photos',
        component: () => import('../views/PhotoManagement.vue')
    },
    {
        path: '/audios',
        name: 'Audios',
        component: () => import('../views/AudioManagement.vue')
    },
    {
        path: '/videos',
        name: 'Videos',
        component: () => import('../views/VideoManagement.vue')
    },
    {
        path: '/document',
        name: 'Document',
        component: () => import('../views/DocumentSearch.vue')
    }
];
// 确保在所有环境中都使用相对路径作为基础
const router = createRouter({
    history: createWebHistory('/'),
    routes,
    strict: true // 严格匹配路径，防止尾随斜杠
});
// 路由守卫：移除尾随斜杠
router.beforeEach((to, from, next) => {
    // 如果路径有尾随斜杠且不是根路径，重定向到没有斜杠的版本
    if (to.path !== '/' && to.path.endsWith('/')) {
        const newPath = to.path.slice(0, -1);
        console.log('[Router] 检测到尾随斜杠，重定向:', to.path, '->', newPath);
        // 使用 replace 避免在历史记录中留下带斜杠的路径
        next({ path: newPath, replace: true });
    }
    else {
        next();
    }
});
export default router;
